import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7500Model } from "../kymw7500.model";

export type GetCatalogInfoResponse = {
  ProgressWorkNum: string;
}[];

/**
 * 受注コードと選択された媒体に紐づく工程管理Noを取得するサービス
 *
 * @export GetCatalogInfoService
 * @class GetCatalogInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCatalogInfoService extends PlessJsonResponderSub<GetCatalogInfoResponse> {
  private model: KYMW7500Model;
  private vo = {
    OrderCode: '',
    MediumType: ''
  }
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCatalogInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode,
        MediumType: this.vo.MediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCatalogInfoService
   */
  execute(model: KYMW7500Model, vo: any, successFunc: Function) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('kymw75GetCatalogInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ 
   * @memberof GetCatalogInfoService 
   */
  success(data: GetCatalogInfoResponse) {
    if (data !== null) {
      this.successFunc(data);
    }
  }
} 